/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { AppProvider } from '@atlaskit/app-provider/app-provider'` instead.
 */
export { default } from './app-provider';

// Theme provider
/**
 * @deprecated Use `import { UNSAFE_useColorModeForMigration } from '@atlaskit/app-provider/use-color-mode-for-migration'` instead.
 */
export { UNSAFE_useColorModeForMigration } from './theme-provider/hooks/use-color-mode-for-migration';
/**
 * @deprecated Use `import { useColorMode } from '@atlaskit/app-provider/use-color-mode'` instead.
 */
export { useColorMode } from './theme-provider/hooks/use-color-mode';
/**
 * @deprecated Use `import { useSetColorMode } from '@atlaskit/app-provider/use-set-color-mode'` instead.
 */
export { useSetColorMode } from './theme-provider/hooks/use-set-color-mode';
/**
 * @deprecated Use `import { useSetTheme } from '@atlaskit/app-provider/use-set-theme'` instead.
 */
export { useSetTheme } from './theme-provider/hooks/use-set-theme';
/**
 * @deprecated Use `import { useTheme } from '@atlaskit/app-provider/use-theme'` instead.
 */
export { useTheme } from './theme-provider/hooks/use-theme';

/**
 * @deprecated Use `import type { Theme } from '@atlaskit/app-provider/theme'` instead.
 */
export type { Theme } from './theme-provider/context/theme';
/**
 * @deprecated Use `import { ThemeProvider, type ThemeProviderProps } from '@atlaskit/app-provider/theme-provider'` instead.
 */
export { ThemeProvider, type ThemeProviderProps } from './theme-provider';

// Router link provider
/**
 * @deprecated Use `import type { RouterLinkComponent, RouterLinkComponentProps } from '@atlaskit/app-provider/router-link-provider'` instead.
 */
export { type RouterLinkComponent, type RouterLinkComponentProps } from './router-link-provider';
import { useRouterLink } from './router-link-provider/hooks/use-router-link';
/**
 * @deprecated Use `import { useRouterLink } from '@atlaskit/app-provider/use-router-link'` instead.
 */
export { useRouterLink };
